var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6168 23C10.5364 23 9.50589 22.7849 8.52544 22.3547C7.545 21.9145 6.68961 21.2992 5.95928 20.5089C5.23895 19.7185 4.72372 18.7881 4.41357 17.7176L8.37538 16.6671C8.58547 17.4575 8.99566 18.0728 9.60593 18.513C10.2262 18.9432 10.8965 19.1583 11.6168 19.1583C12.2371 19.1583 12.8024 19.0082 13.3126 18.708C13.8329 18.4079 14.243 18.0027 14.5432 17.4925C14.8533 16.9823 15.0084 16.417 15.0084 15.7967C15.0084 14.8663 14.6882 14.0709 14.048 13.4106C13.4177 12.7403 12.6073 12.4052 11.6168 12.4052C11.3167 12.4052 11.0266 12.4502 10.7465 12.5402C10.4663 12.6203 10.1962 12.7353 9.93608 12.8854L8.10525 9.67394L14.9784 3.97135L15.2785 4.84175H5.25396V1H18.7601V4.84175L13.4177 10.0041L13.3877 8.86357C14.6282 9.05366 15.6737 9.48886 16.5241 10.1692C17.3845 10.8395 18.0348 11.6699 18.475 12.6603C18.9252 13.6407 19.1503 14.6862 19.1503 15.7967C19.1503 17.1573 18.8051 18.3829 18.1148 19.4734C17.4245 20.5539 16.5091 21.4143 15.3686 22.0546C14.228 22.6849 12.9775 23 11.6168 23Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.f89c1a9c2647f5710336c57453b93f71.svg";
export { ForwardRef as ReactComponent };